module.exports = __webpack_public_path__ + "static/img/constractor_logo1.a2527bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/constractor_logo1.png
// module id = 0msu
// module chunks = 159